// extracted by mini-css-extract-plugin
export default {"notification-container":"Dd90thQMl26QgV29lrGi","hide-notification":"cPzCkzOKNW89XyiS3Tzl"};